import { Alert, AlertTitle, Box, LinearProgress, Snackbar } from "@mui/material";

import { AlertDescriptor } from "./AlertContextProvider.types";
import { AlertMessageIcon } from "./AlertMessageIcon";

// Horizontal distance between the alert stack and the screen edge. The provider anchors the stack
// this far from the right; the snackbar caps its width so the same gap remains on the left on
// narrow (phone) viewports.
export const ALERT_SCREEN_EDGE_OFFSET_PX = 24;

interface Props {
  alert: AlertDescriptor;
  onClose: (alertId: string) => void;
}

export function AlertSnackbar({ alert, onClose }: Props) {
  return (
    <Snackbar
      open={true}
      autoHideDuration={alert.duration}
      onClose={(event, reason) => {
        if (reason === "clickaway") {
          return;
        }
        if (reason === "escapeKeyDown") {
          event.preventDefault();
        }
        onClose(alert.id);
      }}
      sx={{ position: "static", width: "500px", maxWidth: `calc(100vw - ${2 * ALERT_SCREEN_EDGE_OFFSET_PX}px)` }}
    >
      <Box sx={{ width: "100%" }}>
        {alert.duration && (
          <LinearProgress
            variant="determinate"
            color={alert.level}
            value={100}
            sx={{
              height: 4,
              borderRadius: "4px 4px 0 0",
              transformOrigin: "left",
              animation: `shrink ${alert.duration}ms linear forwards`,
              "@keyframes shrink": {
                from: { transform: "scaleX(1)" },
                to: { transform: "scaleX(0)" },
              },
            }}
          />
        )}
        <Alert
          severity={alert.level}
          onClose={() => onClose(alert.id)}
          icon={<AlertMessageIcon level={alert.level} />}
          sx={{
            width: "100%",
            borderRadius: 0.5,
            borderTopLeftRadius: alert.duration ? 0 : 0.5,
            borderTopRightRadius: alert.duration ? 0 : 0.5,
            alignItems: "flex-start",
          }}
        >
          <AlertTitle color="black">{alert.message}</AlertTitle>
          {alert.additionalComponent}
        </Alert>
      </Box>
    </Snackbar>
  );
}
